import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import { ProductsState, RootState } from '@/types/state';
import { Module } from 'vuex';

export const getInitialState = (): ProductsState => ({
  products: [],
  isDataLoaded: false,
});

const state = getInitialState();

const ProductsModule: Module<ProductsState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default ProductsModule;
